import { RecentlyDeletedTableCell } from '~/components/RecentlyDeleted/components/RecentlyDeletedTableCell';
import { getTableColumnWidth } from '~/components/RecentlyDeleted/utils/getTableColumnWidth';

export const RecentlyDeletedTableHeaderCellActions = () => {
  return (
    <RecentlyDeletedTableCell className="bg-grey-1" width={getTableColumnWidth('action')}>
      Actions
    </RecentlyDeletedTableCell>
  );
};
